/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-unresolved */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Box, Card, IconButton, Button,
} from "@mui/material";
import {getDistance, getImage, getLogo} from "helpers/utils";
import { useHistory } from "react-router-dom";

import { Link } from "react-router-dom";
import "./UserSellerShop.scss";
import * as Actions from "actions";
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import {H6, H2} from "components/CustomTypography";

const UserSellerShop = (props) => {
  const [state, setState] = useState({
    open: false,
  });

  const history = useHistory();

  const {
    shop = {}, viewShop, isDirect
  } = props;

  const onOpenModal = () => {
    setState({ open: true });
  };

  const onCloseModal = () => {
    setState({ open: false });
  };

    const handleShopButtonClick = () => {
        history.push(`/shop/${shop.id}`);
    };

  return (
      <Box pb={3} onClick={isDirect ? handleShopButtonClick : viewShop}>
        <HoverBox  mb={0} mx="auto" borderRadius="2px">
          <LazyImage
              src={getImage(shop.logo)}
              width="100%"
              alt={shop.title}
              mx="auto"
          />
        </HoverBox>
        <H2 textTransform="capitalize" fontSize={14} textAlign="left" title={shop.title} ellipsis>
          {shop.title}
        </H2>
        <H6 fontSize={10} textAlign="left">
            {shop.area}
        </H6>
      </Box>
  );
};

export default UserSellerShop;
